// shared/books.ts
// Each account's list of books — the vocabulary shared by api/src/books.ts
// (validation, the source of truth) and the book pickers. An asset's or a
// project's bookCode must be one of the account's books, chosen from a list
// rather than typed, so "IM1", "im1" and "IM 1" can't become three books.
// Codes are matched case-insensitively and stored as the book has them.
// ─────────────────────────────────────────────────────────────────
/** Short code, e.g. IM1: letters, digits, '-' or '_'. Also the folder name for local renders. */
export const BOOK_CODE_RE = /^[A-Za-z0-9_-]{1,20}$/;
export const MAX_BOOK_TITLE = 200;
export const MAX_BOOK_SERIES = 100;
/** A tidiness limit, not a quota. */
export const MAX_BOOKS = 200;
export function isBookCode(v) {
    return typeof v === 'string' && BOOK_CODE_RE.test(v);
}
/** "IM1 — Ignition" for pickers; just the code when there's no title. */
export function bookLabel(b) {
    return b.title ? `${b.bookCode} — ${b.title}` : b.bookCode;
}
